export enum SiteItemStatus {
  Active = 'active',
  InProgress = 'inProgress',
  Deleted = 'deleted',
  Running = 'running',
  ImportPending = 'importpending',
  Pending = 'pending',
  Unavailable = 'unavailable',
}

export type SiteItem = {
  id: number;
  name: string;
  sector: string;
  description: string;
  createdBy: string;
  projects: string[];
  modifiedby: string;
  status: SiteItemStatus;
  observability: string;
  edgeServiceUrl: string;
};

export type SiteEdgeServiceItem = {
  edgeServiceUrl?: string;
};

export enum SiteItemField {
  SiteName = 'name',
  Sector = 'sector',
  Description = 'description',
  CreatedBy = 'createdBy',
  Solutions = 'solutions',
  Status = 'status',
  Projects = 'projects',
  ModifiedBy = 'modifiedby',
  Observability = 'observability',
  EdgeServiceUrl = 'edgeServiceUrl',
}

export type SiteDetailsItem = SiteItem;

export enum SiteNamespace {
  CoreAndCommon = 'coreandcommon-ns',
  KubeSystem = 'kube-system',
}

export type ClusterCommandLinks = {
  remove?: string;
  self?: string;
  update?: string;
};

export type ClusterCommands = {
  baseType?: string;
  clusterId?: string;
  command?: string;
  created?: string;
  createdTS?: number;
  id?: string;
  insecureCommand?: string;
  insecureNodeCommand?: string;
  insecureWindowsNodeCommand?: string;
  links?: ClusterCommandLinks;
  manifestUrl?: string;
  name?: string;
  nodeCommand?: string;
  state?: string;
  token?: string;
  transitioning?: string;
  transitioningMessage?: string;
  type?: string;
  uuid?: string;
  windowsNodeCommand?: string;
};

export type ClusterNode = {
  name: string;
  status: string;
  pods?: string;
  hostName?: string;
  cpuCores: number;
  memoryKi?: string;
  diskEphemeral?: string;
  gpuCount: number;
  operatingSystem?: string;
  kubernetesVersion?: string;
  instanceType?: string;
  ipAddress?: string;
  cpuCoresFormatted?: string;
  memoryFormatted?: string;
  diskSizeFormatted?: string;
  gpuCountFormatted?: string;
  gpuMemoryFormatted?: string;
  cpuUtilized?: string;
  memoryUtilized?: string;
  diskUtilized?: string;
  gpuMemoryUtilized?: string;
  gpuCoreUtilized?: string;
  gpuProduct?: string;
};

export type ClusterNodeNamespaces = {
  Namespaces?: string[];
  Nodes?: ClusterNode[];
};

export type ClusterPod = {
  podName: string;
  imageName: string;
  imageVersion: string;
};

export type ClusterNamespacePods = {
  namespace: string;
  pods: ClusterPod[];
};

export type clusterDetail = {
  clusterId: string;
  clusterLabels: Record<string, string>;
  clusterName: string;
  clusterStatus: string;
  clusterProviderType: string;
  clusterAuthType: string;
  clusterCommands?: ClusterCommands | string;
  nodeNamespaces?: ClusterNodeNamespaces;
  pods?: ClusterNamespacePods[];
  observability?: string;
  kubernetesVersion?: string;
  instanceType?: string;
  operatingSystem?: string;
  cloudConfigRefUid?: string;
};

export type SiteClusterItem = {
  clustersDetail: clusterDetail[];
};
